import React from 'react';
import { useModal } from '../../contexts/ModalContext';
import TaskDetailsModal from './TaskDetailsModal';

const ModalDetalhesProvider: React.FC = () => {
  const { tarefaSelecionada, modalDetalhesAberto, fecharModalDetalhes } = useModal();

  if (!tarefaSelecionada || !modalDetalhesAberto) return null;

  return (
    <TaskDetailsModal 
      tarefa={tarefaSelecionada} 
      aberto={modalDetalhesAberto} 
      onFechar={fecharModalDetalhes} 
    />
  );
};

export default ModalDetalhesProvider;
